import { render } from "./ToggleButton.vue?vue&type=template&id=4c2dd17d"
import script from "./ToggleButton.vue?vue&type=script&lang=js"
export * from "./ToggleButton.vue?vue&type=script&lang=js"
script.render = render

export default script